package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.price_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.TimeIntervalEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.PriceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.getYearsData
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.monthModelToDateString
import org.hs_soft.runmynesto.pages.components.CustomDropDown
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component.AddingCustomAllergene
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.date_picker.DatePickerDialog
import kotlin.math.exp
import kotlin.reflect.typeOf

@Composable
fun AddPriceDialog(
    loading:Boolean,
    onDismissDialog:()->Unit,
    createSpecialPrice:(String,String,String,Int)->Unit,
)
{
    val selectedType= remember { mutableStateOf<PriceTypeEnum?>(null) }
    val startDate= remember { mutableStateOf<MonthModel?>(null)}
    val startTime= remember { mutableStateOf<TimeIntervalEnum?>(null) }
    val label= remember { mutableStateOf("") }
    val showDatePickerDialog= remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onDismissDialog()
            }
    )
    {
        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .backgroundColor(Theme.White.rgb)
                .zIndex(1)
                .boxShadow(
                    color = Theme.ActionDisabledBackground.rgb,
                    blurRadius = Dimen.smallBlurRadius,
                )
                .borderRadius(r= Dimen.semiLargeRadius),
            horizontalAlignment = Alignment.Start
        ){

            DialogTitle(
                title = Strings.current().addNewPrice,
                showCloseIcon = true,
                showSeparator = false,
                onCloseClick = {
                    onDismissDialog()
                },
            )

            Column(
                Modifier
                    .fillMaxWidth()
                    .padding(Dimen.extraLargePadding)
            )
            {
                DropDownItem(
                    modifier = Modifier.margin(
                        right = Dimen.largePadding,
                        bottom = Dimen.highLargePadding,
                    ),
                    fillMaxWidth = true,
                    label = Strings.current().type,
                    options = PriceTypeEnum.entries,
                    itemWidth = Dimen.extraSemiMediumEditText,
                    selectedItem = selectedType.value,
                    displayText = {
                        if (it is PriceTypeEnum)
                            it.title else ""
                    },
                    onOptionClick = {
                        if (it is PriceTypeEnum){
                            selectedType.value= it as? PriceTypeEnum
                        }
                    }
                )

                CustomEditText(
                    value =label.value,
                    marginBottom = Dimen.highLargePadding,
                    width = Dimen.semiLargeEditTextWidth,
                    label = Strings.current().label,
                    isRequired = false,
                    fillMaxWidth = true,
                    onFocusOut = {},
                    onFocusIn = {},
                    onInputChange = { it, _ ->
                        label.value=it
                    }
                )

                CustomDropDown(
                    modifier = Modifier
                        .margin(
                            right = Dimen.largePadding,
                            bottom = Dimen.highLargePadding,
                        ),
                    fillMaxWidth = true,
                    label = Strings.current().startDate,
                    itemWidth = Dimen.normalEditTextWidth2,
                    selectedDisplayContent = {
                        if (startDate.value!=null){
                            extractDate(monthModelToDateString(startDate.value!!) )?.let {
                                SpanText(
                                    text = it,
                                    modifier = Modifier
                                        .fontSize(FontSizes.mediumFontSize)
                                        .color(
                                            Theme.TextPrimary.rgb
                                        )
                                        .fontWeight(FontWeight.Normal)
                                        .fontFamily(FontFamily.Jakarta)
                                )
                            }
                        }


                    },
                    dropdownContent = {expanding->
                        DatePickerDialog(
                            selectedDay = startDate.value ,
                            modifier = Modifier,
                            calendarData = getYearsData(
                                startYear = Constants.startYear,
                                endYear = Constants.endYear
                            ),
                            onSelectDay = {
                              startDate.value=it
                              showDatePickerDialog.value=false
                              expanding.value=false
                            },
                            onBackgroundClick = {
                                expanding.value=false
                                showDatePickerDialog.value=false
                            },
                        )
                    }
                )


                DropDownItem(
                    modifier = Modifier
                        .margin(bottom = Dimen.extraLargePadding),
                    itemWidth = Dimen.normalEditTextWidth2,
                    options = TimeIntervalEnum.entries,
                    fillMaxWidth = true,
                    label = Strings.current().startTime,
                    selectedItem =startTime.value,
                    displayText = {
                        if (it is TimeIntervalEnum)
                            it.title else ""
                    },
                    onOptionClick = {
                        if (it is TimeIntervalEnum){
                            startTime.value=it
                        }
                    }
                )

                CustomButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    buttonType = ButtonTypes.CONTAINED,
                    title = Strings.current().submit,
                    loading =loading ,
                    isClickable =selectedType.value!=null &&
                        label.value.isNotEmpty() && startDate.value!=null
                            && startTime.value!=null,
                    onButtonClick = {
                        if (startDate.value!=null
                            && startTime.value!=null && selectedType.value!=null)
                        {
                            createSpecialPrice(
                                label.value,
                                monthModelToDateString(startDate.value!!),
                                startTime.value?.value?:"",
                                selectedType.value!!.value
                            )
                        }

                    }
                )


            }


        }



    }



}